import { ErrorHandler, Injectable } from '@angular/core';
import { MonitoringService } from './monitoring.service';

@Injectable()
export class MonitoringErrorHandler implements ErrorHandler {
  constructor(private readonly monitoring: MonitoringService) {}

  handleError(error: unknown): void {
    console.error(error);
    this.monitoring.captureException(error);
  }
}
